import RefappBeforeafter from './components/refapp-beforeafter.vue';
import RefappBeforeafterCompare from './components/base/compare.vue';
import RefappBeforeafterProvider from './components/base/provider.vue';

export default {
  install(app) {
    const components = [RefappBeforeafter, RefappBeforeafterCompare, RefappBeforeafterProvider];
    components.forEach((c) => app.component(c.name, c));
  },
};
